import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  isSelected?: boolean;
  backgroundColorValue?: string;
}

export const Root = styled.div`
  font-family: Roboto;
  width: 64px;
  margin-top:6px;
  padding: 0px 4px;
  position: relative;
`;

export const ButtonContainer = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: ${C.WHITE};
  display:flex;
  height: 31px;
  padding: 0px 0px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background-color: ${(props: IRootProps) => props.isSelected ? "#122442" : ""};
  cursor: pointer;
  &:hover {
      background-color: ${C.GRAY}
    }
`;

export const OptionsContainer = styled.div`
  position: absolute;
  top: 48px;
  right: 5px;
  display: flex;
  flex-direction column;
  padding: 28px; 21px 28px 21px;
  background-color: ${C.WHITE};
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  z-index: 10;
`;

export const OptionsRowContainer = styled.div`
  display: flex;
  width: 412px;
  justify-content: space-between;
`;

export const IconContainer = styled.div`
  margin: 0px 5px 0px 5px;
  display: flex;
  flex-direction: column;
  min-width: 58px;
  width: 88px;
  height: 67px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
  &: hover{
    background-color: ${(props: IRootProps) => (props.backgroundColorValue ?? 'auto')};
  }
`;

export const IconText = styled.div`
  margin: 14px 0px 0px 0px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`;

export const LineDivider = styled.div`
  margin: 18px 0px 18px 0px;
  width: 100%;
  height: 1px;
  background-color: ${C.GENERIC_GRAY};
`;